import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more_swatches",
  "use": "more_swatches-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"more_swatches\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\"><circle cx=\"15\" cy=\"15\" r=\"15\" /><path d=\"M22 15.043l-14-.086m7-6.955v13.996\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol